import { EditGroupLocationsForm } from "@/components/forms/groups/EditGroupLocationForm"
import ScreenWrapper from "@/components/ScreenWrapper"
import { createFileRoute, useParams } from "@tanstack/react-router"
import { FormStyle, PageHeader } from "toptaal-shared"

export const Route = createFileRoute(
  "/beheer/groepen/wijzigen/$groupId/locaties-wijzigen",
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { groupId } = useParams({ from: Route.id })

  return (
    <ScreenWrapper>
      <FormStyle className="mx-auto my-8">
        <PageHeader className="mb-8 text-center">Locaties wijzigen</PageHeader>

        <EditGroupLocationsForm groupId={Number(groupId)} />
      </FormStyle>
    </ScreenWrapper>
  )
}
